import React, { useState } from "react"
import { Delighted, Satisfied, Neutral, Dissatisfied, Unhappy } from "./SVGs"

function SatisfactionWrapper({ selectedGrade, setSelectedGrade, setComment }) {
  const [isCommentRequired, setIsCommentRequired] = useState(false)

  const satisfactionNameBasedOnGrade = {
    1: "Muito satisfeito",
    2: "Satisfeito",
    3: "Neutro",
    4: "Insatisfeito",
    5: "Muito insatisfeito",
  }

  const handleGradeSelection = (grade) => {
    setSelectedGrade((prevGrade) => (prevGrade === grade ? null : grade))
    setIsCommentRequired(grade == 3 || grade == 4 || grade == 5 ? true : false)
  }

  const handleCommentChange = (event) => {
    setComment(event.target.value)
  }

  return (
    <>
      <div className="satisfaction-wrapper">
        {[Delighted, Satisfied, Neutral, Dissatisfied, Unhappy].map(
          (Item, index) => (
            <Item
              key={index} // Adding key prop to avoid warning
              selected={selectedGrade === index + 1} // Pass selected prop
              handleGradeSelection={handleGradeSelection}
            />
          )
        )}
      </div>
      <p>{satisfactionNameBasedOnGrade[selectedGrade]}</p>
      <div className="satisfaction-comment-wrapper">
        <p>Justificativa</p>
        <textarea
          placeholder="Escreva aqui..."
          onChange={handleCommentChange}
          required={isCommentRequired}
        ></textarea>
      </div>
    </>
  )
}

export default SatisfactionWrapper
